import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Wrench, ShieldCheck } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { user, authLoading } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user?.is_admin) navigate("/admin/dashboard");
  }, [user, authLoading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] grain px-6">
      <Seo title="Admin Login — Indoforce" description="Store admin login" />
      <div className="relative z-10 w-full max-w-md border border-white/10 bg-[#111111] p-10 text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <span className="grid place-items-center w-9 h-9 bg-[#E31E24] text-black"><Wrench size={20} strokeWidth={2.5} /></span>
          <span className="font-display font-black text-xl tracking-tighter uppercase">Pressure<span className="text-[#E31E24]">Works</span></span>
        </Link>
        <h1 className="font-display text-3xl font-black uppercase tracking-tighter mb-3">Admin Access</h1>
        <p className="text-white/50 text-sm mb-8">Sign in with your authorised Google account to manage products & orders.</p>
        <button
          onClick={login}
          data-testid="google-login-btn"
          className="btn-fill w-full flex items-center justify-center gap-3 border border-[#E31E24] text-[#E31E24] hover:text-black px-8 py-4 uppercase text-sm font-bold tracking-widest"
        >
          Continue with Google
        </button>
        {user && !user.is_admin && (
          <p className="text-[#E63946] text-xs mt-6" data-testid="not-authorized">
            {user.email} is not authorised for admin access.
          </p>
        )}
        <p className="text-white/30 text-[11px] mt-6 flex items-center justify-center gap-2">
          <ShieldCheck size={13} /> Restricted to store owner
        </p>
      </div>
    </div>
  );
}
